import React from "react";
import ReactDOM from "react-dom";
import { StyledEngineProvider, ThemeProvider } from "@mui/material";
import { ThemeProvider as ThemeProviderForStyles } from "@mui/styles";
import styledTheme from "/src/ui/shared/styledTheme";
import "../../i18n";
import { CookieConsentBanner } from "./CookieConsentBanner";
import { isLoggedInByCookie, readConsent } from "./consent";
import { loadAcceptedMetricsForPage, type MetricsPreset } from "./metrics";

declare global {
  interface Window {
    cookieConsentConfig?: {
      preset?: MetricsPreset;
      containerId?: string;
    };
    mountCookieConsent?: () => void;
  }
}

const DEFAULT_CONTAINER_ID = "cookie-consent-root";

export function mountCookieConsent() {
  const config = window.cookieConsentConfig || {};
  const preset = config.preset || "default";
  const containerId = config.containerId || DEFAULT_CONTAINER_ID;

  const consent = readConsent();
  const isLoggedIn = isLoggedInByCookie();

  if (consent === "accepted" || (isLoggedIn && consent !== "necessary")) {
    loadAcceptedMetricsForPage(preset);
  }

  if (isLoggedIn) {
    return;
  }

  const container = document.getElementById(containerId);
  if (!container) {
    return;
  }

  ReactDOM.render(
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={styledTheme}>
        <ThemeProviderForStyles theme={styledTheme}>
          <CookieConsentBanner preset={preset} />
        </ThemeProviderForStyles>
      </ThemeProvider>
    </StyledEngineProvider>,
    container,
  );
}

window.mountCookieConsent = mountCookieConsent;
mountCookieConsent();
